module.exports = __webpack_public_path__ + "img/facebook-post.10a484b3.png";